import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { getStoredLanguage } from "./language";
import { defaultNS, resources } from "./resources";

export const fallbackLng = "en";

i18n.use(initReactI18next).init({
  resources,
  lng: getStoredLanguage() ?? fallbackLng,
  fallbackLng,
  defaultNS,
  fallbackNS: "common",
  returnNull: false,
  // Resources are bundled in-memory, so init synchronously and skip Suspense —
  // keeps first render and vitest setup deterministic (no isInitialized race).
  initAsync: false,
  react: {
    useSuspense: false,
  },
  interpolation: {
    // React escapes by default; i18next escaping would double-encode.
    escapeValue: false,
  },
});

export default i18n;
